import { PaginationProps } from "src/pages/report/shared/types/Pagination";

export const DEFAULT_PAGINATION_CONFIG: PaginationProps = {
  current_page: 1,
  records_per_page: 10,
  total_pages: 0,
  total_records: 0
};